import moment from "moment";

export function getFullNameTZ(name:string) {
    const offset = moment.tz(name).format("Z");
    const fullFormat = `${name} (UTC${offset})`
    return fullFormat;
}